import VirtualDropdown from "common/components/VirtualDropdown"
import { INITIAL_QUERY_PARAMETERS } from "features/Crear/components/LibradoCard/constants"
import useContactoSelector from "features/Tesoreria/hooks/useContactoSelector"
import { useCallback } from "react"
import "./style.scss"

const ContactoSelect = ({
  title,
  className,
  isComprador,
  getClienteProveedor,
  onBlur,
  values,
  razonSocial,
  errors,
  ...props
}: $TSMigrationFixMe) => {
  const {
    onSelectContacto,
    contactoSelected,
    options,
    placeholder,
    loading,
    fetch,
    userKey,
    setIsFilterActive,
    totalCount,
    value,
    onHandleScroll,
  } = useContactoSelector(values?.empresaId, isComprador)

  const handleSelectContact = useCallback(
    (e: $TSMigrationFixMe, value: $TSMigrationFixMe) => {
      onSelectContacto(e, value)
      getClienteProveedor(e.target.value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSelectContacto]
  )

  return (
    <div className='input_box'>
      <label htmlFor='empresaId'>{title}</label>
      <VirtualDropdown
        filter
        options={
          razonSocial
            ? [...options, { label: razonSocial, value: values.empresaId }]
            : options
        }
        onChange={(e: $TSMigrationFixMe) => handleSelectContact(e, value)}
        value={contactoSelected || values?.empresaId}
        placeholder={placeholder}
        emptyFilterMessage='Sin resultados...'
        emptyMessage='Sin resultados...'
        handleOnScroll={onHandleScroll}
        loading={loading}
        startPage={20}
        fetchCallback={fetch}
        initialQueryParameters={INITIAL_QUERY_PARAMETERS}
        userKey={userKey}
        setIsSelectFilterActive={setIsFilterActive}
        totalCount={totalCount}
        className={className}
        onBlur={onBlur}
        name='empresaId'
        id='empresaId'
        errorMsg={errors}
        {...props}
      />
    </div>
  )
}

export default ContactoSelect
